/**
 * Checks wheter a specified zipcode is within range. Specific for polarpump configurator,
 * where zip codes are entered as ranges in AX instead of being specified in a list
 *
 * Ranges looks something like this
 * 83xxx-83089 <- 83000 to 83089
 * 83091-83091 <- business as usual
 * 93123-93xxx <- 93123-93999
 * 55xxx <- 55000-55999
 * @param zipcode - the zipcode to test against
 * @param ranges - zip code range
 */
export const isZipCodeInRange = (zipCode: string, ranges: string[]) => {
  return ranges.some(range => {
    const [from, to] = range.split('-');

    if (to === undefined) {
      const stripped = replacePlaceHolder('', from);
      return stripped === zipCode.substr(0, stripped.length);
    }

    const parsedZipCode = +zipCode;
    const parsedfrom = +replacePlaceHolder('0', from);
    const parsedto = +replacePlaceHolder('9', to);

    return parsedZipCode >= parsedfrom && parsedZipCode <= parsedto;
  });
};

const replacePlaceHolder = (replacement: string, code: string) => code.replace(/x/g, replacement);
